import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsSkillCreatePage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="skills-create"
    />
  );
}
